import styled from "styled-components";
import { Paragraph2, WrapperContainer } from "..";
import { colors } from "../../consts";

export const LabelsInfoWrapper = styled(WrapperContainer)``;

export const LabelInfo = styled(WrapperContainer)`
  ${Paragraph2}, span {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;

    color: ${colors.WHITE};
  }

  span {
    font-weight: 400 !important;
  }
`;

export const ColorIndicator = styled.div`
  width: 8px;
  min-width: 8px;
  height: 8px;
  border-radius: 50%;

  background: ${(props) => (props?.color ? props.color : "transparent")};
`;
